// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1IKMX","buttons":"Footer_buttons__14Owd"};